// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__39B_T","additionalInfo":"AgreementModal_additionalInfo__2TJXx"};